export default interface RoomBlock {
  id: string;
  area: string;
  roomID: string;
  toDate: Date | any;
  fromDate: Date | any;
  quantity: number;
  dueDate: Date;
  responsable: Resposable;
  typePayment?: Payments;
  status: Status;
}
export enum Payments {
  stripe = "stripe",
  deposit = "deposit",
  transfer = "transfer",
  other = "other",
}
export enum Status {
  cancelled = "cancelled",
  paid = "paid",
  pending = "pending",
}
export interface Resposable {
  uid: string;
  displayName: string;
  permission: string;
}
